<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("menu.trans_cancel") }}
          </h6>
        </div>

        <!-- <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="handleCreate()">{{
            $t("new")
          }}</base-button>
        </div> -->
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">{{ $t("menu.trans_cancel") }}</h3>

		  <div class="row">
            <div class="col-lg-2">
              <base-input
                :name="$t('lmg.start_date')"
              >
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ allowInput: true }"
                  :rules="{ required: true }"
                  class="form-control datepicker"
                  v-model="params.start_date"
                >
                </flat-picker>
              </base-input>
            </div>
            <div class="col-lg-2">
              <base-input
                :name="$t('lmg.end_date')"
              >
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ allowInput: true }"
                  :rules="{ required: true }"
                  class="form-control datepicker"
                  v-model="params.end_date"
                >
                </flat-picker>
              </base-input>
            </div>

			

			<div class="col-lg-2">
              <base-input
                :name="$t('lmg.policy_number')"
                input-classes="form-control"
                  v-model="params.policy_number"
                  :placeholder="$t('lmg.policy_number')"
              >
              </base-input>
            </div>

			  <div class="col-md-3">
                <base-button
                  size="md"
                  type="neutral"
                  @click="listData(params)"
                  >
				  {{ $t("search") }}
				  </base-button >
              </div>

          </div>

          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>


			  

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >

			  <el-table-column :label="$t('lmg.policy_number')">
                <div slot-scope="{ row }" class="d-flex">
					{{ row.policy_number }}
				</div>
              </el-table-column>

			  <el-table-column :label="$t('lmg.effect_date')">
                <div slot-scope="{ row }" class="d-flex">
					{{ row.effect_date_show }} 
				</div>
              </el-table-column>


			  <!-- amount -->
			  <el-table-column :label="$t('lmg.refund_amount')">
                <div slot-scope="{ row }" class="d-flex">
					{{ row.refund_amount }} 
				</div>
              </el-table-column>

			  <el-table-column :label="$t('lmg.refund_amount_all')">
                <div slot-scope="{ row }" class="d-flex">
					{{ row.refund_amount_all }} 
				</div>
              </el-table-column>

			  <el-table-column :label="$t('created')">
                <div slot-scope="{ row }" class="d-flex">
					{{ row.created_at_show }} 
				</div>
              </el-table-column>


            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="tableData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <h1>{{ $t('lmg.wht') }}</h1>

      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="new-event--form" @submit.prevent="handleSubmit(onUpdateWht)">
        <base-input :label="$t('lmg.bank_name')" v-model="md.Name" :name="$t('lmg.bank_name')" rules="required"> </base-input>

        <base-input :label="$t('lmg.bank_account')" v-model="md.AccountNumber" :name="$t('lmg.bank_account')" rules="required">
        </base-input>

      <div class="modal-footer">

        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </div>
      </form>
      </validation-observer>

    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { TimeGrid } from '@fullcalendar/timegrid';

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
	flatPicker,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      tableData: "Transaction/getCancel",
	  tablePerson: "Person/getDataWithAll",
    }),
    
    tableColumns: function() {
      return [
        {
          prop: "Name",
          label: this.$t("lmg.agent"),
          minWidth: 90,
          sortable: true
        },
        {
          prop: "AccountNumber",
          label: this.$t("lmg.bank_account"),
          minWidth: 100,
          sortable: true
        }
      ];
    }
  },
  data() {
    return {
      propsToSearch: ["policy_number"],
      selectedRows: [],
      showAddModal: false,
      md: {
        ID: "",
        Name: "",
        AccountNumber: ""
      },


	  params:{
		policy_number : "",
		start_date : "",
		end_date : "",

	  }
    };
  },
  mounted() {
	this.params.start_date = this.getStartDate();
	this.params.end_date = this.getEndDate();
    this.listData(this.params);
  },
  methods: {
    ...mapActions({
      listData: "Transaction/listCancel",
    }),
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
